import IconNotAcid from "../../../assets/svg/icon-not-acid.svg";
import IconNotFire from "../../../assets/svg/icon-not-fire.svg";
import IconComment from "../../../assets/svg/icon-comment.svg";

export const CORNSTARCH_ITEMS = [
  {
    type: "title",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.title",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconNotAcid,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.notAcid",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconNotFire,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.notHeat",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconComment,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.instruction",
  },
];

export const MCT_OIL_ITEMS = [
  {
    type: "text",
    translatable: false,
    description: "Take as prescribed by your physician",
  },
];

export const TRIHEPTANOIN_ITEMS = [
  {
    type: "text",
    translatable: false,
    description:
      "Take at least four times per day and as prescribed by your physician",
  },
  {
    type: "text",
    translatable: false,
    description: "Take with food/beverage/ formula (medical food)",
  },
  {
    type: "text",
    translatable: false,
    description:
      "Mix Triheptanoin thoroughly with food/ beverage/ formula (medical food)",
  },
  {
    type: "text",
    translatable: false,
    description: "Do not cook or bake with Triheptanoin",
  },
  {
    type: "text",
    translatable: false,
    description: "Do not take with even chain MCT oil or products with MCT",
  },
];

export const FOOD_DRINK_ITEMS = [
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.description",
    ],
  },
];

export const GLYCOSADE_ITEMS = [
  {
    type: "title",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.glycosade.title",
  },
];
